function getStep4Module1State(state) {
  return {
    products: state.step4Module1.products,
    credits: state.step4Module1.products,
    availablePlans: state.step4Module1.availablePlans,
    currentPlan: state.step4Module1.currentPlan,
    userTypeId: state.user.info.userTypeId,
    selectedOperationTypeId: state.step1Module1.formValues.selectedOperationTypeId,
    freeError: state.step4Module1.freeError,
    freeResponse: state.step4Module1.freeResponse,
    freeAvailable: state.step4Module1.freeAvailable,
    eligibleForUpgrade: state.step4Module1.eligibleForUpgrade,
    creditsCompleted: state.step4Module1.creditsCompleted
  };
}

export { getStep4Module1State };
